import { render, staticRenderFns } from "./edit-action.vue?vue&type=template&id=73aab9fd&scoped=true&"
import script from "./edit-action.vue?vue&type=script&lang=js&"
export * from "./edit-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aab9fd",
  null
  
)

export default component.exports